/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/requisicao/actionsTypes';
import BaseService from '../services/BaseService';
import FileService from '../services/FileService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';
import { createdRequisicoes } from '../views/v2/Requisicoes/requisicaoArea';

const errorMessage = (error, fallback) => {
  if (error.response && error.response.data && error.response.data.mensagem) {
    return error.response.data.mensagem;
  }
  return fallback;
};

function* fetchCatalogo() {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.get({ url: 'catalogo/itens' });
    yield put({
      type: TypeActions.REQUISICAO_FETCH_CATALOGO_SUCCESS,
      data: response.data || [],
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: errorMessage(error, 'Erro ao carregar o catálogo!'),
    });
  }
}

function* criar({ data, callback }) {
  const arquivos = data.arquivos || [];
  const payload = {
    ...data,
    arquivos: arquivos.map((arquivo) => ({
      nome: arquivo.nome,
      extensao: arquivo.extensao,
      externalId: arquivo.id,
      entityId: arquivo.entityId,
    })),
  };
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: 'requisicoes', data: payload });
    const created = createdRequisicoes(response && response.data);
    if (arquivos.length) {
      for (let index = 0; index < created.length; index += 1) {
        const arquivosResposta = created[index] && created[index].arquivos;
        if (arquivosResposta && arquivosResposta.length) {
          yield FileService.uploadArquivos(arquivos, arquivosResposta);
        }
      }
    }
    if (callback) yield callback(true, created.length > 1 ? created : created[0]);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: created.length > 1
        ? `Pedido separado em ${created.length} requisições.`
        : 'Requisição enviada!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    console.log(error);
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: errorMessage(error, 'Erro ao criar a requisição!'),
    });
  }
}

function* atualizar({ id, data, callback }) {
  const arquivos = data.arquivos || [];
  const payload = {
    ...data,
    arquivos: arquivos.map((arquivo) => ({
      ...(arquivo.new ? {} : { id: arquivo.id }),
      nome: arquivo.nome,
      extensao: arquivo.extensao,
      externalId: arquivo.id,
      entityId: arquivo.entityId,
    })),
  };
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.put({ url: `requisicoes/${id}`, data: payload });
    const novos = arquivos.filter((arquivo) => arquivo.file);
    if (response && response.data && response.data.arquivos && novos.length) {
      yield FileService.uploadArquivos(novos, response.data.arquivos);
    }
    if (callback) yield callback(true, response && response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Requisição atualizada!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    console.log(error);
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: errorMessage(error, 'Erro ao atualizar a requisição!'),
    });
  }
}

function* excluir({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.delete({ url: `requisicoes/${id}` });
    if (callback) yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Requisição excluída!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    console.log(error);
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: errorMessage(error, 'Erro ao excluir a requisição!'),
    });
  }
}

function* findById({ id }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.get({ url: `requisicoes/${id}` });
    yield put({
      type: TypeActions.REQUISICAO_FIND_ONE_SUCCESS,
      data: response.data,
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: errorMessage(error, 'Erro ao carregar a requisição!'),
    });
  }
}

function* mutate({ request, successMessage, fallbackError, callback, putSelected }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield request();
    if (putSelected && response && response.data && response.data.id) {
      yield put({
        type: TypeActions.REQUISICAO_FIND_ONE_SUCCESS,
        data: response.data,
      });
    }
    if (callback) yield callback(true, response && response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: successMessage,
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    console.log(error);
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: errorMessage(error, fallbackError),
    });
  }
}

function* aprovarParcial({ id, data, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `requisicoes/${id}/aprovar-parcial`, data }),
    successMessage: 'Decisões salvas com sucesso!',
    fallbackError: 'Erro ao aprovar a requisição!',
    callback,
    putSelected: true,
  });
}

function* cancelar({ id, data, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `requisicoes/${id}/cancelar`, data }),
    successMessage: 'Requisição cancelada!',
    fallbackError: 'Erro ao cancelar a requisição!',
    callback,
    putSelected: true,
  });
}

function* criarEntregas({ id, data, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `requisicoes/${id}/entregas`, data }),
    successMessage: 'Entregas criadas!',
    fallbackError: 'Erro ao criar entregas!',
    callback,
    putSelected: true,
  });
}

function* atualizarEntrega({ id, data, callback }) {
  yield* mutate({
    request: () => BaseService.put({ url: `entregas/${id}`, data }),
    successMessage: 'Entrega atualizada!',
    fallbackError: 'Erro ao atualizar a entrega!',
    callback,
    putSelected: true,
  });
}

function* cancelarEntrega({ id, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `entregas/${id}/cancelar` }),
    successMessage: 'Entrega cancelada!',
    fallbackError: 'Erro ao cancelar a entrega!',
    callback,
    putSelected: true,
  });
}

function* despachar({ id, data, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `entregas/${id}/despachar`, data }),
    successMessage: 'Entrega despachada!',
    fallbackError: 'Erro ao despachar a entrega!',
    callback,
    putSelected: false,
  });
}

function* finalizar({ id, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `entregas/${id}/finalizar` }),
    successMessage: 'Entrega finalizada!',
    fallbackError: 'Erro ao finalizar a entrega!',
    callback,
    putSelected: false,
  });
}

function* rastreamento({ id, data, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `entregas/${id}/rastreamento`, data }),
    successMessage: 'Evento de rastreamento registrado!',
    fallbackError: 'Erro ao registrar rastreamento!',
    callback,
    putSelected: false,
  });
}

function* pedidoReceber({ id, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `pedidos/${id}/receber` }),
    successMessage: 'Pedido marcado como recebido!',
    fallbackError: 'Erro ao receber o pedido!',
    callback,
    putSelected: false,
  });
}

function* pedidoCancelar({ id, data, callback }) {
  yield* mutate({
    request: () => BaseService.post({ url: `pedidos/${id}/cancelar`, data }),
    successMessage: 'Pedido cancelado!',
    fallbackError: 'Erro ao cancelar o pedido!',
    callback,
    putSelected: false,
  });
}

function* fetchDisponibilidade({ requisicaoId, itemId }) {
  try {
    const response = yield BaseService.get({
      url: `requisicoes/${requisicaoId}/itens/${itemId}/disponibilidade`,
    });
    yield put({
      type: TypeActions.REQUISICAO_FETCH_DISPONIBILIDADE_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    console.log(error);
    yield put({ type: TypeActions.REQUISICAO_FETCH_DISPONIBILIDADE_ERROR });
  }
}

export default function* watchRequisicao() {
  yield takeLatest(TypeActions.REQUISICAO_FIND_ONE, findById);
  yield takeLatest(TypeActions.REQUISICAO_FETCH_CATALOGO, fetchCatalogo);
  yield takeLatest(TypeActions.REQUISICAO_CREATE, criar);
  yield takeLatest(TypeActions.REQUISICAO_UPDATE, atualizar);
  yield takeLatest(TypeActions.REQUISICAO_DELETE, excluir);
  yield takeLatest(TypeActions.REQUISICAO_APROVAR_PARCIAL, aprovarParcial);
  yield takeLatest(TypeActions.REQUISICAO_CANCELAR, cancelar);
  yield takeLatest(TypeActions.REQUISICAO_CRIAR_ENTREGAS, criarEntregas);
  yield takeLatest(TypeActions.REQUISICAO_ATUALIZAR_ENTREGA, atualizarEntrega);
  yield takeLatest(TypeActions.REQUISICAO_CANCELAR_ENTREGA, cancelarEntrega);
  yield takeLatest(TypeActions.REQUISICAO_DESPACHAR_ENTREGA, despachar);
  yield takeLatest(TypeActions.REQUISICAO_FINALIZAR_ENTREGA, finalizar);
  yield takeLatest(TypeActions.REQUISICAO_RASTREAMENTO, rastreamento);
  yield takeLatest(TypeActions.REQUISICAO_PEDIDO_RECEBER, pedidoReceber);
  yield takeLatest(TypeActions.REQUISICAO_PEDIDO_CANCELAR, pedidoCancelar);
  yield takeLatest(TypeActions.REQUISICAO_FETCH_DISPONIBILIDADE, fetchDisponibilidade);
}
